// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/@kmijs+bundler-compiled@0.0.8/node_modules/@kmijs/bundler-compiled/compiled/css-loader/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/@kmijs+bundler-compiled@0.0.8/node_modules/@kmijs/bundler-compiled/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fullscreen___TdARR {\n  padding: 20rem;\n  background-color: #fff;\n  overflow: auto;\n}\n", "",{"version":3,"sources":["webpack://./../../features/common/src/components/FullScreenButton/index.less"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,sBAAA;EACA,cAAA;AACF","sourcesContent":[".fullscreen {\n  padding: 20px;\n  background-color: #fff;\n  overflow: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fullscreen": "fullscreen___TdARR"
};
export default ___CSS_LOADER_EXPORT___;
